export {pluralize} from './noun';
